"use client";

import TechnologiesCard from "./technologies-card";
import { useTechnologiesPageData } from "../../hooks/useTechnologiesPageData";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const TechnologiesList = () => {
  const { technologies } = useTechnologiesPageData();

  if (!technologies || !technologies.technologies?.length || technologies.loading) {
    return null;
  }

  return (
    <Container>
      <div className={S.technologiesWrapper}>
        {technologies.technologies.map(item => (
          <TechnologiesCard key={item.id} item={item} />
        ))}
      </div>
    </Container>
  );
};

export default TechnologiesList;
